import { render, staticRenderFns } from "./BplSeasonUserRatingHistory.vue?vue&type=template&id=25f9d81b&scoped=true"
import script from "./BplSeasonUserRatingHistory.vue?vue&type=script&lang=js"
export * from "./BplSeasonUserRatingHistory.vue?vue&type=script&lang=js"
import style0 from "./BplSeasonUserRatingHistory.vue?vue&type=style&index=0&id=25f9d81b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f9d81b",
  null
  
)

export default component.exports